var gb2260 = {};
(function (gb2260) {
  var GB2260 = function (param) {
    this._data = param.data;
  };

  GB2260.prototype.get = function (code) {
    code = code.toString();
    if (code.length !== 6) {
      throw new Error('Invalid code');
    }

    var name = this._data[code];
    if (!name) {
      return null;
    }

    var division = new Division(code, name);

    if (/0{4}$/.test(code)) {
      return division;
    }

    var provinceCode = code.substr(0, 2) + '0000';
    name = this._data[provinceCode];
    division.province = new Division(provinceCode, name);

    if (/0{2}$/.test(code)) {
      return division;
    }

    var prefectureCode = code.substr(0, 4) + '00';
    name = this._data[prefectureCode];
    division.prefecture = new Division(prefectureCode, name);
    return division;
  };

  GB2260.prototype.codes = function () {
    if (!this._codes) {
      // this._codes = Object.keys(this._data).sort();
      this._codes = _.sortBy(_.keys(this._data));
    }
    return this._codes;
  };

  GB2260.prototype.provinces = function () {
    var me = this;
    var rv = [],
      name;
    // this.codes().forEach(function(k) {
    //     if (/0{4}$/.test(k)) {
    //         name = me._data[k];
    //         rv.push(new Division(k, name));
    //     }
    // });

    _.each(this.codes(), function (k) {
      if (/0{4}$/.test(k)) {
        name = me._data[k];
        rv.push(new Division(k, name));
      }
    });

    return rv;
  };

  GB2260.prototype.prefectures = function (code) {
    code = code.toString();
    if (!/0{4}$/.test(code)) {
      throw new Error('Invalid province code');
    }

    var name = this._data[code];
    if (!name) {
      throw new Error('Invalid province code');
    }

    var me = this;
    var province = new Division(code, name);
    var pattern = new RegExp('^' + code.substr(0, 2) + '\\d{2}00$');
    var rv = [],
      division;

    // this.codes().forEach(function(k) {
    //     if (pattern.test(k) && k !== code) {
    //         name = me._data[k];
    //         division = new Division(k, name);
    //         division.province = province;
    //         rv.push(division);
    //     }
    // });

    _.each(this.codes(), function (k) {
      if (pattern.test(k) && k !== code) {
        name = me._data[k];
        division = new Division(k, name);
        division.province = province;
        rv.push(division);
      }
    });

    return rv;
  };

  GB2260.prototype.counties = function (code) {
    code = code.toString();
    if (!/[1-9]0{2,3}$/.test(code)) {
      throw new Error('Invalid prefecture code');
    }

    var name = this._data[code];
    if (!name) {
      throw new Error('Invalid prefecture code');
    }
    var me = this;
    var prefecture = new Division(code, name);

    var provinceCode = code.substr(0, 2) + '0000';
    name = me._data[provinceCode];
    var province = new Division(provinceCode, name);

    var pattern = new RegExp('^' + code.substr(0, 4));
    var rv = [],
      division;

    // this.codes().forEach(function(k) {
    //     if (pattern.test(k) && k !== code) {
    //         name = me._data[k];
    //         division = new Division(k, name);
    //         division.province = province;
    //         division.prefecture = prefecture;
    //         rv.push(division);
    //     }
    // });

    _.each(this.codes(), function (k) {
      if (pattern.test(k) && k !== code) {
        name = me._data[k];
        division = new Division(k, name);
        division.province = province;
        division.prefecture = prefecture;
        rv.push(division);
      }
    });

    return rv;
  };


  var Division = function (code, name) {
    this.code = code;
    this.name = name;
  };

  gb2260.GB2260 = GB2260;
})(gb2260);